"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSpinner = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  border-width: ", "px;\n  border-style: solid;\n\n  border-color: ", ";\n\n  border-top-color: ", ";\n\n  flex: 0 0 ", "px;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  animation: spin 1.25s infinite linear;\n\n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])), function (p) {
  return p.lineWidth;
}, function (p) {
  return p.theme.colorSpinnerRail || p.forDark ? (0, _polished.rgba)("white", 0.275) : (0, _polished.rgba)("black", 0.1);
}, function (p) {
  return p.theme.colorSpinnerAccent || (p.forDark ? "white" : p.theme.colorPrimary);
}, function (p) {
  return Math.floor(p.lineWidth * 7);
}, function (p) {
  return Math.floor(p.lineWidth * 7);
}, function (p) {
  return Math.floor(p.lineWidth * 7);
});

var Spinner = function Spinner(_ref) {
  var colorPrimary = _ref.colorPrimary,
      className = _ref.className,
      lineWidth = _ref.lineWidth,
      forDark = _ref.forDark;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSpinner, {
    colorPrimary: colorPrimary,
    className: className,
    lineWidth: lineWidth,
    forDark: forDark
  });
};

Spinner.defaultProps = {
  lineWidth: 7,
  forDark: false
};
Spinner.propTypes = {
  lineWidth: _propTypes.default.number,
  forDark: _propTypes.default.bool,
  colorPrimary: _propTypes.default.string
};
var _default = Spinner;
exports.default = _default;